(function (window, angular, undefined) {
	angular.module('formApp')
	.provider('tat', function(){
		this.$get = function($) {
			return {
				routetouse: this.getRoute(),
			};
		};

		function getQueryVariable(variable) {
			var query = window.location.search.substring(1);
			var vars = query.split("&");
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split("=");
				if (pair[0] === variable) { return pair[1]; }
			}
			return (false);
}
		this.getRoute = function(){

			var routeType = getQueryVariable("routeType");
			
			if(routeType === 'combined'){
				return {route:'combined'};
			}
			else{
				return {route:'single'};
			}
		};
	});
})(window, window.angular);